exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".solution-panel{color:#fff;padding:3.2rem 15px}.solution-panel h2{padding-bottom:8px;font-size:1.875rem;font-weight:500}.solution-panel p{max-width:790px;padding-bottom:4px;font-size:1rem;font-weight:300;line-height:19px;letter-spacing:.12px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/SolutionPanel/SolutionPanel.scss
// module id = 7717
// module chunks = 13